export { default } from "./PowerWordPopoutBody";
